import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { DataSharingService } from '../data-sharing/data-sharing.service';
import { environment } from '../../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class SocketServiceService {
  private socket: any;
  private socketUrl: string = environment.socketUrl; // Replace with your socket server URL http://localhost:5000  https://www.dhanbet.in:8443
  private messageSubject = new Subject<any>(); // Subject to handle incoming messages
  private currentStream: string = '';

  // Connect to the socket server
  connect(token: any): void {
    this.socket = io(this.socketUrl, {
      auth: { token: `Bearer ${token}` },
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
    });

    this.socket.io.engine.binaryType = 'arraybuffer';

    this.socket.on('connect', () => {
      if (this.currentStream) {
        console.log('Connected to the socket server!', this.currentStream);

        this.socket.emit('switchStream', [this.currentStream]);
      }
    });

    this.socket.on('disconnect', (reason: any) => {
      console.log('Disconnected from the socket server!', reason);
    });

    this.socket.on('connect_error', (error: any) => {
      console.log('Connection error:', error.message);
    });
  }
  // Emit an event to the socket server
  emit(event: string, data: any): void {
    if (event === 'switchStream') {
      this.currentStream = Array.isArray(data) ? data[0] : data; // 👈 save single stream
    }
    if (this.socket) {
      this.socket.emit(event, data);
    }
  }

  // Listen for events from the socket server
  listen(event: string): Observable<any> {
    return new Observable((observer) => {
      const eventHandler = (data: any) => observer.next(data);
      this.socket?.on(event, eventHandler);

      return () => {
        this.socket?.off(event, eventHandler); // Cleanup when unsubscribed
      };
    });
  }

  // Disconnect the socket
  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  getSocketIntance(): any {
    return this.socket;
  }
}
